import { useEffect } from "react";
import { useCursor } from "../contexts/CursorContext";
import { getCursorStyle, CursorType } from "../config/cursorConfig";

export const useCursorManager = () => {
  const { activeCursor, setActiveCursor } = useCursor();

  useEffect(() => {
    // Find canvas element
    let canvasElement = document.querySelector(
      '[data-workspace-canvas="true"] canvas'
    ) as HTMLElement;

    if (!canvasElement) {
      canvasElement = document.querySelector("canvas") as HTMLElement;
    }

    if (!canvasElement) {
      return;
    }

    // Apply cursor based on active cursor type
    if (activeCursor) {
      canvasElement.style.cursor = getCursorStyle(activeCursor);
    } else {
      canvasElement.style.cursor = "auto";
    }

    return () => {
      if (canvasElement) {
        canvasElement.style.cursor = "auto";
      }
    };
  }, [activeCursor]);

  const setCursorByState = (cursorType: CursorType | null) => {
    setActiveCursor(cursorType);
  };

  const toggleCursor = (cursorType: CursorType | null) => {
    setActiveCursor(activeCursor === cursorType ? null : cursorType);
  };

  return {
    activeCursor,
    setActiveCursor,
    setCursorByState,
    toggleCursor,
  };
};
